module.exports = __webpack_public_path__ + "static/img/twjd-sdw1.c9b617e.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/twjd-sdw1.png
// module id = 871
// module chunks = 0